import { VStack } from "@chakra-ui/react";

import { useSchoolsContext } from "../../../../Contexts/schoolContext";
import { Level, Subject } from "../../../../services/Dtos";
import SubjectBar from "./SubjectBar";

interface Props {
  handleEditSubject: (subject: Subject) => void;
  level: Level;
}

export default function SubjectTable({ handleEditSubject, level }: Props) {
  const { subjects } = useSchoolsContext();
  return (
    <VStack w="100%" align="stretch">
      {subjects
        .filter((sub) => sub.levelId === level.id)
        .map((s) => (
          <SubjectBar
            key={s.id}
            subject={s}
            handleEditSubject={handleEditSubject}
          />
        ))}
    </VStack>
  );
}
